module.exports = __webpack_public_path__ + "media/images/profile/vip-099b1e5b6272e144413ed5cd39bba7fa.svg";